import { isNil, isEmpty, size, isFunction } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { TimelineMax, TweenMax } from 'gsap';
import FilterMixin from './FilterMixin';

// define a mixin object
export default {

  data() {
    return {
      hotelSettings: null,
    };
  },

  computed: {
    hotelSpiderName: function () {
      if (isNil(this.hotelSettings) || isNil(this.hotelSettings.hotel)) return 'Hotel Spider';
      switch (this.hotelSettings.hotel.whiteLabel) {
        // case 'Rainmaker':
        //   return 'rainmaker.switch';
        default:
          return 'Hotel Spider';
      }
    },
    suApiVersion: function () {
      if (!isFunction(this.hasLicense)) return null;
      if (!this.hasLicense('InterfaceCmConnectS')) return null;
      if (isNil(this.hotelSettings)) return null;
      if (isNil(this.hotelSettings.interfaces)) return null;
      if (isNil(this.hotelSettings.interfaces.connectS)) return null;
      // if (this.hotelSettings.interfaces.connectS.enabled !== true) return null;
      if (isNil(this.hotelSettings.interfaces.connectS.apiVersion)) return 'v1';
      else return this.hotelSettings.interfaces.connectS.apiVersion;
    },
  },

  created: function () {
    this.__setHotelSettings();
  },

  methods: {
    __setHotelSettings: function () {
      this.hotelSettings = this.$store.getters['hotel/hotelSettings'];
      if (isNil(this.hotelSettings) || isNil(this.hotelSettings.details)) {
        setTimeout(this.__setHotelSettings, 100);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/HotelSettingsMixin.js